// Libraries
import { object, string, date, boolean } from 'yup'
// Constants
import { EXPERIENCE_MODAL_SIZES } from '../../../../constants/modals'
import { Text } from '../../../../constants/TextConstants'

const getIsCurrentlyWorkValue = (isCurrentlyWork) => {
  if (Array.isArray(isCurrentlyWork) && isCurrentlyWork.length > 0) {
    return isCurrentlyWork[0]
  }
  return isCurrentlyWork
}

export const EXPERIENCE_MODAL_SCHEMA = () =>
  object().shape({
    jobDateFrom: date().required(Text.Required).typeError(Text.ValidDate),
    isCurrentlyWork: boolean(),
    jobDateTo: date()
      .typeError(Text.ValidDate)
      .when('isCurrentlyWork', (isCurrentlyWork, schema) =>
        getIsCurrentlyWorkValue(isCurrentlyWork) ? schema.nullable(true) : schema.required(Text.Required)
      ),
    jobTitle: string()
      .required(Text.Required)
      .max(
        EXPERIENCE_MODAL_SIZES.maxLengthJobTitle,
        `Job title must be at most ${EXPERIENCE_MODAL_SIZES.maxLengthJobTitle} characters`
      ),
    industrySector: string().required(Text.Required)
      .max(
        EXPERIENCE_MODAL_SIZES.maxLengthJobTitle,
        `Industry sector must be at most ${EXPERIENCE_MODAL_SIZES.maxLengthIndustrySector} characters`
      ),
    projectName: string().max(
      EXPERIENCE_MODAL_SIZES.maxLengthProjectName,
      `Project name must be at most ${EXPERIENCE_MODAL_SIZES.maxLengthProjectName} characters`
    ),
    jobAndResponsibilities: string().max(
      EXPERIENCE_MODAL_SIZES.maxLengthJobResponsibilities,
      `Project responsibilities must be at most ${EXPERIENCE_MODAL_SIZES.maxLengthJobResponsibilities} characters`
    ),
    projectDescription: string().max(
      EXPERIENCE_MODAL_SIZES.maxLengthProjectDescription,
      `Project description must be at most ${EXPERIENCE_MODAL_SIZES.maxLengthProjectDescription} characters`
    ),
    additionalInfo: string().max(
      EXPERIENCE_MODAL_SIZES.maxLengthAdditionalInfoTitle,
      `Additional info title must be at most ${EXPERIENCE_MODAL_SIZES.maxLengthAdditionalInfoTitle} characters`
    ),
    additionalInfoDesc: string().max(
      EXPERIENCE_MODAL_SIZES.maxLengthAdditionalInfoDesc,
      `Additional info must be at most ${EXPERIENCE_MODAL_SIZES.maxLengthAdditionalInfoDesc} characters`
    ),
    achievements: string().max(
      EXPERIENCE_MODAL_SIZES.maxLengthAchievements,
      `Achievements must be at most ${EXPERIENCE_MODAL_SIZES.maxLengthAchievements} characters`
    )
  })
